<template>
  <b-container>
    <!-- User Interface controls -->
    <BusquedaRut></BusquedaRut>  
    <div class="text-left my-3" > 
      Búsqueda Nombre<input type="text" v-model="query_nombre"  @keyup="mayus">
     </div>
    <b-row>
      <b-col sm="5" md="6" class="my-1">
        <b-form-group
          label="Seleccione "
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            v-model="perPage"
            id="perPageSelect"
            size="sm"
            :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

    <!-- Main table element -->
      <!--stacked="md"-->
    <b-table
      sticky-header
      id="table-transition-personas"
      show-empty
      small
      :items="traerdatapersonas"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      :tbody-transition-props="transProps"
      primary-key="fecha"
    >
      <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>

    </b-table>

    <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
    </b-modal>
  </b-container>
</template>

<script>
import BusquedaRut from '../components/BusquedaRut'
  export default {
    name:'Personas2',
    components:{
        BusquedaRut
    },
    data() {
      
      return {
          query_nombre:'',
          transProps: {
          // Transition name
          name: 'flip-list'
        },       
        fields: [
          // { key: 'fecha', label: 'Fecha Ingreso', sortable: true, sortDirection: 'desc', class:'text-left' },
          { key: 'rut', label: 'Rut', sortable: true, sortDirection: 'desc', class:'text-left' },
          { key: 'nombre', label: 'Nombres', sortable: true, sortDirection: 'desc', class:'text-left' },
          { key: 'departamento', label: 'Depto', sortable: true, class: 'text-center' },
          { key: 'residente', label: 'Tipo', sortable: true, class: 'text-center' },
          

          //{ key: 'actions', label: 'Actions' }
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 5,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        }
      }
      
    },
    computed: {
      traerdatapersonas(){
          return this.$store.getters.enviardatapersonas.filter(datos => {
                return datos.nombre.includes(this.query_nombre.toUpperCase())
            }); 
      },
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
    mounted() {
      // Set the initial number of items
      this.totalRows = this.traerdatapersonas.length
    },
    methods: {
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },     
       mayus() {            
            this.query_nombre = this.query_nombre.toUpperCase();
        },
    }
  }
</script>

<style>
table#table-transition-personas .flip-list-move {
  transition: transform 1s;
}
</style>